export default __webpack_public_path__ + "static/media/GothamSSm-Bold.ddf8d6c3.ttf";